import React from 'react';
import './DetailSingle.css';

const DetailSingle = ({detail}) => {
     const{image, title, titleOne, titleTwo, titleThree, LiveSite, ClientSide, ServerSide} = detail || {};
     return (
          <div  className="w-full ">
           <h3 style={{textAlign:'center', marginTop:'60px', marginBottom:'40px', fontWeight:'bold', fontSize:'26px'}}> Project Links</h3>
    <div style={{height:'5px', width:'50px', background:'#E54042', margin:'0 auto', marginTop:'-30px', marginBottom:'30px'}}></div>

          <div className="my-4 md:mx-4 shadow p-6 rounded-md bg-white group ">
            <div className="relative mb-6 w-full h-48 bg-purple-200 rounded-md overflow-hidden">
              <img
                src={image}
                alt="coverImage"
                className="w-full h-full object-cover object-center"
              />
              <div className="absolute opacity-0 transition duration-200 bg-purple-100 bg-opacity-80 w-full flex items-center justify-center h-full left-0 top-0 group-hover:opacity-100 group-hover:visible">
                
              </div>
            </div>
            <h3 style={{marginTop:'60px'}} className="text-lg font-medium text-gray-800 mb-2">{title}</h3>

          <div>
          <a className="projects-link" href={LiveSite}> Live site |</a>
          <a className="projects-link" href={ClientSide}>Client side |</a>
          <a className="projects-link" href={ServerSide}>Server side</a>
          </div>

            <p style={{marginTop:'26px'}} className="text-black ">- {titleOne}</p>
            <p style={{marginTop:'26px'}}  className="text-black">- {titleTwo}</p>
            <p style={{marginTop:'26px'}}  className="text-black">- {titleThree}</p>
          </div>
        </div>
     );
};

export default DetailSingle;